import React from "react";
import { Home, Banknote, TrendingUp, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: TrendingUp,
    tag: "01 — Placement",
    title: "Donner du sens à votre épargne",
    desc: "De la défiscalisation aux placements à fort potentiel, je structure votre épargne pour la faire rapporter intelligemment et préparer chaque étape de votre vie financière.",
    image: "https://images.pexels.com/photos/9755376/pexels-photo-9755376.jpeg",
    bullets: ["Assurance-vie, PER, SCPI, private equity...", "Défiscalisation (Titres participatifs, Denormandie, Girardin...)", "Préparation retraite & transmission..."],
  },
  {
    icon: Home,
    tag: "02 — Assurance",
    title: "Protéger ce qui compte vraiment",
    desc: "Une couverture sur-mesure pour vous, votre famille et votre activité. Je négocie auprès des meilleurs assureurs des garanties solides au juste prix, sans clause cachée.",
    image: "https://images.unsplash.com/photo-1526958097901-5e6d742d3371",
    bullets: ["Emprunteur, auto, habitation...", "Santé, prévoyance, dépendance...", "RC pro, mutuelle entreprise, homme-clé..."],
  },
  {
    icon: Banknote,
    tag: "03 — Crédit",
    title: "Financements sur-mesure",
    desc: "Crédit immobilier, rachat de crédits, prêt pro. Je négocie pour vous les meilleures conditions auprès de mes partenaires bancaires.",
    image: "https://images.pexels.com/photos/15422346/pexels-photo-15422346.jpeg",
    bullets: ["Crédit immobilier neuf & ancien", "Rachat & regroupement", "Prêt professionnel"],
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-md-bg relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.25em] text-md-accent font-bold mb-4">Mes domaines d'expertise</div>
          <h2 className="font-serif text-4xl md:text-5xl text-md-primary font-medium leading-tight">
            Du financement à la transmission, <span className="italic">je vous accompagne</span> sur tous les leviers de votre patrimoine.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className="group bg-white rounded-3xl overflow-hidden border border-md-border hover:border-md-secondary/40 hover:-translate-y-1 transition-all duration-500 shadow-sm hover:shadow-xl"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-md-primary/70 via-md-primary/10 to-transparent" />
                  <div className="absolute top-4 left-4 bg-white/95 backdrop-blur rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-bold text-md-primary">
                    {s.tag}
                  </div>
                  <div className="absolute bottom-4 left-4 w-12 h-12 rounded-2xl bg-md-secondary grid place-items-center text-white">
                    <Icon className="w-6 h-6" />
                  </div>
                </div>

                <div className="p-7">
                  <h3 className="font-serif text-2xl text-md-primary font-medium mb-3">{s.title}</h3>
                  <p className="text-md-muted text-[15px] leading-relaxed mb-5">{s.desc}</p>
                  <ul className="space-y-2 mb-6">
                    {s.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2 text-sm text-md-text">
                        <span className="text-md-secondary mt-1">→</span>
                        {b}
                      </li>
                    ))}
                  </ul>
                  <a
                    href="#devis"
                    data-testid={`service-cta-${i}`}
                    className="inline-flex items-center gap-2 text-md-primary font-semibold text-sm hover:text-md-secondary transition-colors"
                  >
                    Demander un conseil
                    <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
